module.exports = __webpack_public_path__ + "img/fsni_1.7edab028.jpg";